import { NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class MismappedEventsReportCriteria extends ValueObject  
{
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";
}